import { Button, makeStyles } from '@material-ui/core'
import React from 'react'
import { errors } from '../../utils/colors'

const useStyles = ({ variant, startIcon, disabled = false }) => {
	const outlinedButton = {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		},
		backgroundColor: '#fff',
		color: errors[900],
		borderColor: errors[900],
		padding: startIcon ? '7px 40px 8px 24px' : 'auto',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	}
	if (variant !== 'outlined') {
		outlinedButton.backgroundColor = errors[900]
		outlinedButton.color = '#fff'
		outlinedButton['&:hover'] = {
			background: '#EB4C4C',
			color: '#fff'
		}
	}
	if (disabled) {
		outlinedButton.backgroundColor = `${errors[500]} !important`
	}
	return makeStyles(() => ({
		outlinedButton
	}))
}

export const DangerButton = ({
	label,
	startIcon,
	onClick,
	variant = 'outlined',
	disabled = false,
	size = 'large'
}) => {
	const classes = useStyles({
		variant,
		startIcon,
		disabled
	})()

	return (
		<Button
			variant={variant}
			disableElevation={true}
			className={classes.outlinedButton}
			startIcon={startIcon}
			size={size}
			onClick={onClick}
			disabled={disabled}>
			{label}
		</Button>
	)
}
